import imageCompression from 'browser-image-compression';

export const uploadService = {
  /**
   * Compress and upload profile image
   * @param {File} file - Image file from input
   * @param {Function} apiCall - Authenticated API call function
   * @returns {Promise<string>} - Uploaded image URL
   */
  uploadProfileImage: async (file, apiCall) => {
    try {
      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 1920, 
        useWebWorker: true,
        fileType: 'image/webp',
      };

      const compressedFile = await imageCompression(file, options);

      const formData = new FormData();
      formData.append('image', compressedFile);

      const response = await apiCall('/api/upload/profile-image', {
        method: 'POST',
        body: formData,
        headers: {

        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Upload failed');
      }

      const data = await response.json();
      return data.data.profilePicture;
    } catch (error) {
      throw new Error(`Failed to upload image: ${error.message}`);
    }
  },
  deleteProfileImage: async (apiCall) => {
    try {
      const response = await apiCall('/api/upload/profile-image', {
        method: 'DELETE',
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Delete failed');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Failed to delete image: ${error.message}`);
    }
  },
};